import { render } from "./performance-setting.vue?vue&type=template&id=3154a267"
import script from "./performance-setting.vue?vue&type=script&lang=js"
export * from "./performance-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__